export default {
  heading: 'Choose the right add-on for you',
  mobileHeading: 'Need help choosing add-ons?',
  description:
    'Try our add-on recommendation tool to help you find which add-ons can get you the most out of your SMARTY plan.',
  buttonTxt: 'Get started',
}
